import { render, staticRenderFns } from "./ChangePasswordRoute.vue?vue&type=template&id=6294b2f3&"
import script from "./ChangePasswordRoute.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports